"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["size", "color", "direction", "accessibleTitle"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var directionMap = {
  right: 'rotate(180 8 8)',
  down: 'rotate(270 8 8)',
  left: 'rotate(0 8 8)',
  up: 'rotate(90 8 8)'
};

/**
 * @deprecated Use <Arrow[direction] /> instead
 */
var Arrow = function Arrow(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#000' : _ref$color,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'left' : _ref$direction,
    _ref$accessibleTitle = _ref.accessibleTitle,
    accessibleTitle = _ref$accessibleTitle === void 0 ? '' : _ref$accessibleTitle,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    style: {
      width: size,
      height: size,
      minWidth: size,
      minHeight: size
    },
    viewBox: "0 0 16 16",
    "aria-hidden": !accessibleTitle
  }, otherProps), accessibleTitle ? /*#__PURE__*/_react["default"].createElement("title", null, accessibleTitle) : null, /*#__PURE__*/_react["default"].createElement("g", {
    transform: directionMap[direction]
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M5.95 3.05a1 1 0 0 1 0 1.414L3.414 7 15 7a1 1 0 0 1 0 2H3.414l2.536 2.536a1 1 0 0 1-1.414 1.414L.293 8.707a1 1 0 0 1 0-1.414L4.536 3.05a1 1 0 0 1 1.414 0z"
  })));
};
Arrow.propTypes = {
  size: _propTypes["default"].number,
  color: _propTypes["default"].string,
  accessibleTitle: _propTypes["default"].string,
  direction: _propTypes["default"].string
};
var _default = exports["default"] = Arrow;